import React, { useEffect, useMemo, useState } from "react";

function useDebouncedValue(value, delayMs = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}

const SearchBar = ({
  value,
  onChange,
  onSubmit,
  placeholder = "Search",
  className = "",
  debounceMs = 0,
  onDebouncedChange,
}) => {
  const [localValue, setLocalValue] = useState(value || "");
  const debounced = useDebouncedValue(localValue, debounceMs);

  useEffect(() => {
    setLocalValue(value || "");
  }, [value]);

  const lastSent = React.useRef(null);

  useEffect(() => {
    if (debounceMs > 0 && typeof onDebouncedChange === "function") {
      if (lastSent.current === debounced) return; // 🔥 prevent infinite loop
      lastSent.current = debounced;
      onDebouncedChange(debounced);
    }
  }, [debounced, debounceMs, onDebouncedChange]);


  const handleSubmit = (e) => {
    if (e?.preventDefault) e.preventDefault();
    if (typeof onSubmit === "function") onSubmit();
  };

  const handleClear = () => {
    setLocalValue("");
    if (typeof onChange === "function") onChange({ target: { value: "" } });
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%" }} className={className}>
      <div className="position-relative d-flex justify-content-start">
        <input
          type="text"
          className="form-control ps-5 py-2"
          placeholder={placeholder}
          aria-label={placeholder}
          value={localValue}
          onChange={(e) => {
            setLocalValue(e.target.value);
            if (typeof onChange === "function") onChange(e);
          }}
          style={{
            borderRadius: "50px",
            border: "1px solid var(--light-gray)",
            color: "var(--light-gray)",
          }}
        />
        <button
          type="submit"
          className="position-absolute btn p-0"
          aria-label="Submit search"
          style={{
            left: "15px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            zIndex: 10,
            color: "var(--light-gray)",
          }}
        >
          <i className="fas fa-search" />
        </button>
        {localValue && (
          <button
            type="button"
            onClick={handleClear}
            className="position-absolute btn p-0"
            aria-label="Clear search"
            style={{
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              zIndex: 10,
              color: "var(--light-gray)",
            }}
          >
            <i className="fas fa-times" />
          </button>
        )}
      </div>
    </form>
  );
};

export default SearchBar;


